<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="box-offset" v-if="!loading">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    FAQ
                </div>
            </div>
            <div id="accordion" class="accordion">
                <div class="accordion--card"
                     v-for="faq in faqList"
                     :key="faq.id"
                >
                    <button class="accordion--btn accordion--btn-underline-sm collapsed" data-toggle="collapse" :data-target="`#faq-${faq.id}`" aria-expanded="false" :aria-controls="`faq-${faq.id}`">
                        {{faq.question}}
                    </button>
                    <div :id="`faq-${faq.id}`" class="collapse" data-parent="#accordion" >
                        <div class="faq-content">
                            <p>{{faq.answer}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <p>
                    If you have any additional questions, please call the ORNA Office at <a href="tel:305-945-5022">305-945-5022</a> or go to the Support tab and someone will get back to you as soon as possible.
                </p>
            </div>
        </div>
    </div>
</template>

<script>

import FaqService from "../../../../FAQ/resources/js/Services/FaqService";

export default {
    name: 'EmployeeFaq',
    data() {
        return {
            loading: true,
            faqList: [],
        }
    },
    methods: {
        async getFaqList() {
            try {
                const { data: response } = await FaqService.getListOfFaqs()
                this.faqList = response
                console.log(this.faqList)
                this.loading = false

            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
    },
    mounted() {
        this.getFaqList()
    }
}

</script>

<style scoped>

</style>
